export default __webpack_public_path__ + "static/media/LAS0910.34I-41210_-24589_0.cf1a9348.jpg";